import { Injectable } from '@angular/core';
import { APP_VERSION, BUILD_DATE } from '../../environment';

@Injectable({ providedIn: 'root' })
export class VersionService {
  readonly version: string = APP_VERSION;
  readonly buildDate: string = BUILD_DATE;

  get displayVersion(): string {
    return `v${this.version}`;
  }

  get formattedBuildDate(): string {
    return new Date(this.buildDate).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }
}
